module.exports = __webpack_public_path__ + "img/New-Romantics.a17b9ef3.jpg";